export default function OrganizationProfileSettingsSkeleton() {
  return (
    <div className="animate-pulse px-3 py-4 md:px-4 md:py-4 lg:px-6 lg:py-6">
      {/* Organization account card: logo + name/country/division/address fields */}
      <div className="mb-4 rounded-lg bg-white p-5 shadow-[0px_2px_4px_0px_rgba(39,51,51,0.1)]">
        <div className="mb-6 flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-neutralExtraLight" />
          <div className="flex flex-col gap-2">
            <div className="h-5 w-48 rounded bg-neutralLight" />
            <div className="h-4 w-32 rounded bg-neutralLight" />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={index}
              className="flex flex-col gap-2"
            >
              <div className="h-3 w-20 rounded bg-neutralLight" />
              <div className="h-10 w-full rounded bg-neutralExtraLight" />
            </div>
          ))}
        </div>
      </div>

      {/* Region settings card: Default / Supervisor / Field Technician sections */}
      <div className="mb-4 rounded-lg bg-white p-5 shadow-[0px_2px_4px_0px_rgba(39,51,51,0.1)]">
        {Array.from({ length: 3 }, (_, index) => (
          <div
            key={index}
            className={index === 0 ? '' : 'mt-8'}
          >
            <div className="mb-2 h-4 w-40 rounded bg-neutralLight" />
            <div className="mb-3 h-3 w-64 rounded bg-neutralExtraLight" />
            <div className="h-10 w-full rounded bg-neutralExtraLight lg:min-w-96" />
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-3">
        <div className="h-10 w-24 rounded-lg bg-neutralLight" />
        <div className="h-10 w-24 rounded-lg bg-neutralExtraLight" />
      </div>
    </div>
  );
}
